module.exports = __webpack_public_path__ + "static/media/card-hosting-br.e51bcb29.png";